module.exports = __webpack_public_path__ + "static/media/fsyuce025.1f39d7a8.jpg";